var live_comments = function()
{
	var instance = {};
	
	//Set scope variable to init dbtable with options, columns etc
	instance.init = function(scope, componentKey, component)
	{
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		scope[componentKey].total = 0;
		scope[componentKey].data = {};
		scope[componentKey].config = component.config;
	};
	instance.update = function(scope, componentKey, resultComponentVal)
	{
		//initalise component properties
		var config = scope[componentKey].config;
		scope[componentKey] = {};
		scope[componentKey].total = resultComponentVal.total;
		scope[componentKey].data = resultComponentVal.data;
		scope[componentKey].instance = {};
		scope[componentKey].config = config

		//run live loading functionality here
		var url = config.url;
		var app_state = scope.appState;

        if (typeof timeout !== 'undefined' && timeout != null) {
            // Never mind, cancel the scheduled task.
            clearTimeout(timeout);
            timeout = null;
        }
        else
        {
            timeout = null;
        }

        //A worker function to run at a particular interval to fetch data from the api
        function worker() 
        {
            var last_item_timestamp = $('#'+componentKey).data('last_item_timestamp');
            var params = {'app_state' : app_state, 'component_key' : componentKey, 'last_record_received_timestamp' : last_item_timestamp};
            if (typeof last_item_timestamp !== typeof undefined && last_item_timestamp !== false) {
                // Request data from API
                $.ajax({
                    url: url,
                    data:params,
                    method: 'POST',
                    withCredentials: true,
                    dataType: 'json',
                    // contentType: 'application/x-www-form-urlencoded',
                    headers: {"X-Requested-With" : "XMLHttpRequest"},
                    xhrFields: { withCredentials: true },
                    success: function(response) {

                        if(typeof response.data != 'undefined' && response.data.length > 0)
                        {
                            var responseData = response.data;
                            var componentData = typeof responseData[componentKey] != 'undefined' && typeof responseData[componentKey].data != 'undefined'?responseData[componentKey].data:responseData;
                            //prepend to the existing data
                            var html = '<div class="row wrapper animated fadeInDown">';

                            var i = 0;
                            $.each(componentData, function(itemKey, item)
                            {
                                if(i==0)
                                {
                                    last_item_timestamp = item.time_stamp;
                                }
                                //Add table header data
                                html += '<div class="col-xs-12 col-sm-12 col-md-12">'+
                                    '<div class="post-heading">'+item.title+' <i class="fa fa-fw fa-circle '+item.color+'"></i></div>'+
                                    '<div class="post default">'+
                                    '<span class="arrow bottom"></span>'+
                                    '<p>'+item.comment+' Testdata</p>'+
                                    (typeof item.experiance != 'undefined'?'<span class="label label-default"><i class="fa fa-fw fa-file-text-o"></i> '+item.experiance+'</span>':'')+
                                    '</div>'+
                                    '<div class="post-details">'+
                                    '<div class="time">'+item.date_time+'</div>'+
                                    '<div class="author">'+item.customer_name+'</div>'+
                                    '</div>'+
                                    '</div>';
                                i++;
                            });
                            html += '</div>';
                            $('#'+componentKey).prepend(html); // prepend the existing html
                            $('#'+componentKey).attr('data-last_item_timestamp', last_item_timestamp); // update new timestamp

                            var sidebar_visible = scope.isSidebarVisible();
                            var sidebar_open = $('#sidebar-right').hasClass('sidebar-right-open');
                            // var sidebar_visible = angular.element('#sidebar-right').scope().isSidebarVisible();

                            //show only on pages where sidebar is allowed & sidebar is closed
                            if(sidebar_visible && !sidebar_open)
                            {
                                //show new messages alert
                                var messages_count = componentData.length;
                                Messenger.options = {
                                    extraClasses: 'messenger-fixed messenger-on-top messenger-on-right',
                                    theme: 'future'
                                };
                                msg = Messenger().post({
                                    message : "You have "+messages_count+" new comments!",
                                    type : 'info',
                                    hideAfter: 4,
                                    hideOnNavigate: true,
                                    showCloseButton: false,
                                    events: {
                                        "click": function(e){
                                            msg.hide(1000);
                                            //Open sidebar
                                            if(!$('#sidebar-right').hasClass('sidebar-right-open'))
                                            {
                                                $('#sidebar-right').toggleClass("sidebar-right-open");
                                                $("#toggle-right .fa").toggleClass("fa-indent fa-dedent");
                                            }
                                        }
                                    }
                                });
                            }
                        }

                    },
                    complete: function() {
                        // Schedule the next request when the current one's complete
                        if($('#'+componentKey).length)
                        {
                            //keep calling the worker function whenever there is a success response
                            timeout = setTimeout(worker, 60000);
                        }
                    }
                });
            }
        }

        //call the worker after a particlar time interval
        timeout = setTimeout(worker, 60000);

	};

	return instance;
};
